import { render } from "./CharacterBox.vue?vue&type=template&id=1f979a70"
import script from "./CharacterBox.vue?vue&type=script&lang=js"
export * from "./CharacterBox.vue?vue&type=script&lang=js"

import "./CharacterBox.vue?vue&type=style&index=0&id=1f979a70&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__